module.exports = __webpack_public_path__ + "img/business.8bb1fb47.jpg";